import { faChevronRight } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Switch, Typography, UserRole } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useChildPasscodeModalStore } from "./useChildPasscodeModalStore"
import { SelectRow } from "../../../../components/selectRow/SelectRow"
import { ChildPasscodeStep } from "../../../../types"
import useSelectedFamilyMember from "../../hooks/useSelectedFamilyMember"

const ChildPasscodeSection = () => {
  const { onOpen: onOpenChildPasscodeModal, setStep } =
    useChildPasscodeModalStore()
  const { selectedProfile } = useSelectedFamilyMember()
  const { t } = useTranslation()

  if (selectedProfile?.role !== UserRole.CHILD) return null

  const isChildAccessCodeEnabled =
    selectedProfile?.user.account_passcode !== null

  return (
    <div className="flex flex-col gap-2">
      <Typography variant="bodyBold">{t("CCP_ACCESS_SECURITY")}</Typography>
      <div className="w-full flex flex-col gap-[10px] p-3 border border-borderPrimary rounded-md bg-backgroundPrimary">
        <div className="w-full flex flex-row gap-2 items-center justify-between">
          <Typography variant="bodySmallBold">
            {isChildAccessCodeEnabled
              ? t("CCP_ACCESS_ON")
              : t("CCP_ACCESS_OFF")}
          </Typography>
          <Switch
            checked={isChildAccessCodeEnabled}
            onChange={() => {
              isChildAccessCodeEnabled
                ? setStep(ChildPasscodeStep.DELETE_PASSCODE)
                : setStep(ChildPasscodeStep.SET_PASSCODE)
              onOpenChildPasscodeModal()
            }}
            name="parentAccessCode"
            variant="small"
          />
        </div>
        {isChildAccessCodeEnabled ? (
          <div className="flex flex-col gap-2">
            <Typography variant="bodySmall">
              {t("CCP_ENABLED_DESC", { name: selectedProfile?.user.name })}
            </Typography>
            <SelectRow
              onClick={() => {
                setStep(ChildPasscodeStep.SET_PASSCODE)
                onOpenChildPasscodeModal()
              }}
            >
              <Typography variant="bodySmall">
                {t("CCP_ACCESS_CODE")}
              </Typography>

              <div className="flex flex-row gap-1 items-center justify-center">
                <Typography variant="bodySmall">
                  {selectedProfile?.user.account_passcode}
                </Typography>
                <FontAwesomeIcon
                  icon={faChevronRight}
                  color={JoonUIColor.icon.neutral}
                />
              </div>
            </SelectRow>
          </div>
        ) : (
          <Typography variant="bodySmall">
            {t("CCP_DISABLED_DESC", { name: selectedProfile?.user.name })}
          </Typography>
        )}
      </div>
    </div>
  )
}

export default ChildPasscodeSection
